import { useEffect, useMemo, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import PageMeta from '@/components/feature/PageMeta';
import SiteLayout from '@/components/feature/SiteLayout';
import SearchResults from '@/pages/search/components/SearchResults';
import { popularSearches, searchFilms } from '@/lib/catalog';

export default function SearchPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const rawKeyword = searchParams.get('q') ?? '';
  const keyword = rawKeyword.trim();
  const [draft, setDraft] = useState(rawKeyword);

  useEffect(() => {
    setDraft(rawKeyword);
  }, [rawKeyword]);

  const results = useMemo(() => searchFilms(keyword), [keyword]);

  const runSearch = (value: string) => {
    const word = value.trim();
    setDraft(word);
    navigate(word ? `/search?q=${encodeURIComponent(word)}` : '/search');
  };

  return (
    <PageMeta
      title={keyword ? `${keyword} 搜索结果 - 91在线视频` : '搜索 - 91在线视频 - 高清影视在线播放平台'}
      description={
        keyword
          ? `在91在线视频搜索「${keyword}」，查看匹配的电影、电视剧与综艺作品，快速了解详情与相关推荐。`
          : '在91在线视频搜索你想看的电影、电视剧与综艺节目，支持标题模糊匹配，快速找到影视详情。'
      }
      keywords="影视搜索,91在线视频,搜索电影,搜索电视剧,搜索综艺"
    >
      <SiteLayout padded>
        <div className="w-full border-b border-background-200 bg-background-100">
          <div className="w-full px-4 md:px-8 py-8 md:py-10">
            <form
              onSubmit={(event) => {
                event.preventDefault();
                runSearch(draft);
              }}
              className="flex flex-col sm:flex-row items-stretch sm:items-center gap-2 max-w-3xl"
            >
              <div className="relative flex-1">
                <input
                  value={draft}
                  onChange={(event) => setDraft(event.target.value)}
                  type="search"
                  name="q"
                  placeholder="搜索影视作品名称、题材或地区"
                  className="w-full h-11 md:h-12 pl-10 pr-4 text-sm rounded-md bg-background-50 border border-background-300 text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400"
                />
                <i className="ri-search-line absolute left-3.5 top-1/2 -translate-y-1/2 text-foreground-400 text-base" />
              </div>
              <button
                type="submit"
                className="h-11 md:h-12 px-6 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium whitespace-nowrap transition-colors cursor-pointer"
              >
                搜索
              </button>
            </form>
          </div>
        </div>

        <SearchResults keyword={keyword} results={results} suggestions={popularSearches} onSearch={runSearch} />
      </SiteLayout>
    </PageMeta>
  );
}